<template>
  <div>
    <div class="page-title">New Submission Visualization</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="create"
      btnText="Add Submission Visualization"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.submission-contents.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.SubmissionContent.new();
      this.form = data;
    },
    async create() {
      await this.$api.SubmissionContent.create(this.form);
      this.$router.push("/widgets/submission-forms");
    },
  },
};
</script>

<style></style>
